import { render } from "./EmptyDataAction.vue?vue&type=template&id=79cfc330&scoped=true&ts=true"
import script from "./EmptyDataAction.vue?vue&type=script&lang=ts"
export * from "./EmptyDataAction.vue?vue&type=script&lang=ts"

import "./EmptyDataAction.vue?vue&type=style&index=0&id=79cfc330&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79cfc330"]])

export default __exports__